export default {
  state: {
    representativePrices: [],
    loading: false,
    filterString: null,
  },
  getters: {
    representativePrices: state => state.representativePrices,
    loading: state => state.loading,
    filterString: state => state.filterString,
  },
  mutations: {
    setRepresentativePrices(state, representativePrices) {
      state.representativePrices = representativePrices;
    },
    setLoading(state, loading) {
      state.loading = loading;
    },
    setFilterString(state, filter) {
      state.filterString = filter;
    },
  },
  actions: {
    async fetchAll({ commit, state, dispatch }, queryString) {
      commit('setLoading', true);
      try {
        if (queryString) {
          commit('setFilterString', queryString);
        } else if (queryString === '') {
          commit('setFilterString', '');
        } else {
          commit('setFilterString', state.filterString || '');
        }
        const representativePrices = await axios.get(`api/product-representative-prices${state.filterString}`);
        commit('setRepresentativePrices', representativePrices);
      } catch (e) {
      }
      commit('setLoading', false);
    },
    async update({ commit }, prices) {
      await axios.put('api/product-representative-prices', prices);
    },
  },
};
